<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Dennis K. Hausker is a retired financial consultant and Vietnam war veteran who graduated from Michigan State University in 1969. He is an avid fan of Spartan sports and enjoys traveling, attending family events, and savoring good food. Dennis met his wife, who hails from Maine and was a warm and nurturing teacher, while they were both in college. They have been happily married ever since. Dennis is known for his positive attitude, which he believes is the key to a fulfilling life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?a43c68c8